<app-mat-select-filtered [items]="entities"
  [valueColumn]="'conceptCode'"
  [descriptionColumns]="['conceptCode','description']"
  ngbTooltip="{{tooltipText}}" placement="bottom"
  [loading]="loading" [multiple]="multiple"
  [ngModel]="value" (ngModelChange)="onSelectedValueChange($event)" [placeHolder]="placeHolder" name="selectedValue" [required]="required">
</app-mat-select-filtered>
